import { render, staticRenderFns } from "./StrategiesTemplate.vue?vue&type=template&id=24201afa&scoped=true&"
import script from "./StrategiesTemplate.vue?vue&type=script&lang=js&"
export * from "./StrategiesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StrategiesTemplate.vue?vue&type=style&index=0&id=24201afa&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24201afa",
  null
  
)

export default component.exports